import React from 'react';
import ModalWrapper from './ModalWrapper';
import CustomButton, { ButtonType } from 'components/custom-button/CustomButton';
import { CrownIcon, FSMSubscriptionIcon } from 'assets/icons';
import { VoidFn } from 'types/baseTypes';
import useFSMPlanInfo from 'containers/integrations/fsm-integration/hooks/useFSMPlanInfo';

const features = [
  'Assign jobs with Service Areas',
  'Track referrals using External Companies',
  'Dispatch faster with Map View',
  'Monitor your business with Reports',
  'Save time with Pay Runs & Accounting tools'
];

type UpgradeFSMModalProps = {
  onStartTrial: VoidFn;
  onComparePlans: VoidFn;
  isLoading: boolean;
};

const UpgradeFSMModal: React.FC<UpgradeFSMModalProps> = ({ onStartTrial, onComparePlans, isLoading }) => {
  const { fsmPlusPlan } = useFSMPlanInfo();

  const subscriptionPrice = fsmPlusPlan?.formattedPrice ?? '$99.99';

  const handleChatWithUsClick = () => {
    if (window.fcWidget) window.fcWidget.open();
  };

  return (
    <ModalWrapper>
      <div
        className="customTransparentScroll max-h-[90vh] w-[90%] max-w-4xl
      overflow-auto rounded-2xl bg-white p-6 shadow-xl md:w-[579px]">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-secondaryBtn">
          <FSMSubscriptionIcon className="h-10 w-10" />
        </div>
        <h2 className="mb-2 text-center text-2xl font-bold text-heading">
          Manage your jobs and team with Field Serve Plus
        </h2>
        <p className="mb-6 text-center text-17px text-primaryText">
          Dispatch your team, track pay, and manage jobs from anywhere.
        </p>
        <div className="mb-8 w-full rounded-md border border-borderGray bg-white p-4">
          <div className="mb-4 text-sbase font-semibold text-primaryText">Do even more on your Field Serve Plus</div>
          <ul className="list-none space-y-4">
            {features.map((feature, idx) => (
              <li key={idx} className="flex items-center gap-x-2 text-sbase text-primaryText">
                <CrownIcon />
                {feature}
              </li>
            ))}
          </ul>
        </div>
        <CustomButton
          isLoading={isLoading}
          className="mb-4 h-12 w-full font-semibold"
          type={ButtonType.PRIMARY}
          id="start-fsm-trial"
          onClick={onStartTrial}>
          Upgrade to Field Serve Plus for {subscriptionPrice} / month
        </CustomButton>
        <CustomButton
          type={ButtonType.SECONDARY}
          id="compare-fsm-plans"
          onClick={onComparePlans}
          className="h-12 w-full border-gray-1 font-semibold">
          Compare plans
        </CustomButton>
        <div className="mt-4 text-center text-sbase font-medium text-accentText">
          Need help?{' '}
          <button
            type="button"
            onClick={handleChatWithUsClick}
            className="cursor-pointer font-bold text-secondary"
            tabIndex={0}
            aria-label="Chat with us">
            Chat with us
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default UpgradeFSMModal;
